import React from "react";
import GenericVideoCamera from "./GenericVideoCamera"; // Video Camer
import MapComponent from "./MapComponent"; // Map Component
import ValueImageChart from "./ValueImageChart"; // Chart + Image Component
import GenericImageCapture from "./GenericImageCamera";
import DynamicVLMSensor from "./DynamicVLMSensor"; // Dynamic VLM Sensor

// Component mapping based on uiType
const componentMap = {
  video_camera: GenericVideoCamera,
  image_camera: GenericImageCapture,
  map: MapComponent,
  no_of_cars: ValueImageChart,
  no_of_people: ValueImageChart,
  dynamic_vlm: DynamicVLMSensor,
};

const SensorComponentRenderer = ({ uiType, sensorId }) => {
  const Component = componentMap[uiType] || null;

  if (!Component) return <div>Unsupported UI Type</div>;

  // Special handling for no_of_cars and no_of_people (pass label)
  const extraProps =
    uiType === "no_of_cars"
      ? { label: "Number of Cars" , dataKey : "numberofcars" }
      : uiType === "no_of_people"
      ? { label: "Number of People", dataKey : "numberofpeople"}
      : {};

  return <Component sensorId={sensorId} {...extraProps} />;
};

export default SensorComponentRenderer;
